document.addEventListener('DOMContentLoaded', () => {
	const post_content = document.querySelector('section.post-content .content')
	const toc = document.querySelector('section.post-content .sidebar .toc')
	const headings = post_content?.querySelectorAll('h2.wp-block-heading')

	if (headings) {
		let title = document.createElement('h6')
		title.innerText = 'Table of Contents'
		toc.appendChild(title)

		let list = document.createElement('ul')

		headings.forEach(h => {
			if (!h.id) {
				// If no id, create one from the title content
				let new_id = encodeURIComponent(h.innerText)
				h.setAttribute('id', new_id)
			}

			let li = document.createElement('li')
			let anchor = document.createElement('a')
			anchor.setAttribute('href', `#${h.id}`)
			anchor.innerText = h.innerText
			li.appendChild(anchor)
			list.appendChild(li)
		})

		toc.appendChild(list)
	}
})
